import Vue from "vue";
import {
  BaseApiRoutes,
  BaseApiGetters,
  ApiAsyncHelper,
} from "@/modules/core/classes/Api";

import { ActivityEntry } from "@/modules/activities/viewmodels/ActivityEntry";

export const state = {
  activityEntries: [],
};

export const getters = Object.assign(
  {
    all: (state) => {
      return state.activityEntries;
    },
    entriesForActivity: (state) => (ActivityId) => {
      return state.activityEntries.filter((e) => e.activity_id === ActivityId);
    },
    lastEntryForActivity: (state) => (ActivityId) => {
      let elements = state.activityEntries.filter(
        (e) => e.activity_id === ActivityId
      );
      return elements.length > 0
        ? elements.reduce((a, b) => (a.created_at > b.created_at ? a : b))
        : false;
    },
  },
  new BaseApiGetters(
    process.env.VUE_APP_BASE_URL + "/api/activity-entries",
    ActivityEntry,
    {},
    {
      /**
       * Returns all system and my activities
       * this.$store.getters['activityentry/api'].Custom.My()
       */
      My: async () => {
        const api = new ApiAsyncHelper();
        let err;
        const ApiResult = await api.$http
          .get(process.env.VUE_APP_BASE_URL + "/api/activity-entries/my", {})
          .catch((e) => {
            console.error(e);
            err = e;
          });

        if (err) return false;

        let data = ApiResult.data.data.map((Entry) => {
          return new ActivityEntry(Entry);
        });

        Vue.set(state, "activityEntries", data);

        return data;
      },

      /**
       * Returns all entries of last week
       * this.$store.getters['activityentry/api'].Custom.Week()
       */
      Week: async () => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/activity-entries/lastweek",
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new ActivityEntry(Entry);
        });

        let el = state.activityEntries.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.activityEntries.push(data);
        }

        return data;
      },

      /**
       * Returns last entry for activity
       * this.$store.getters['activityentry/api'].Custom.ActivityLast(ActivityId)
       */
      ActivityLast: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/activities/" + Id + "/lastentry",
          {}
        );

        if (ApiResult.data.data === false) return false;

        let data = new ActivityEntry(ApiResult.data.data);

        let el = state.activityEntries.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.activityEntries.push(data);
        }

        return data;
      },

      /**
       * Returns all entries for activity of last week
       * this.$store.getters['activityentry/api'].Custom.ActivityWeek(ActivityId)
       */
      ActivityWeek: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/activities/" +
            Id +
            "/entrieslastweek",
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new ActivityEntry(Entry);
        });

        let el = state.activityEntries.find((e) => e.id === data.id);
        if (el) {
          el = data;
        } else {
          state.activityEntries.push(data);
        }

        return data;
      },

      /**
       * Returns all entries for activity
       * this.$store.getters['activityentry/api'].Custom.Activity(ActivityId)
       */
      Activity: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL + "/api/activities/" + Id + "/entries",
          {}
        );

        let data = ApiResult.data.data.map((Entry) => {
          return new ActivityEntry(Entry);
        });

        data.forEach((d) => {
          let el = state.activityEntries.find((e) => e.id === d.id);
          if (el) {
            el = d;
          } else {
            state.activityEntries.push(d);
          }
        });

        return data;
      },

      /**
       * Returns stats for all entries of period
       * this.$store.getters['activityentry/api'].Custom.AllActivityStats(ActivityId, Params)
       */
      AllActivityStats: async (Id, Params) => {
        let params = Params;

        if (typeof params !== "object") {
          params = { range: params };
        }

        const api = new ApiAsyncHelper();
        const ApiResult = await api
          .call(
            "get",
            process.env.VUE_APP_BASE_URL +
              "/api/activities/" +
              Id +
              "/all-entries-stats",
            { params }
          )
          .catch((err) => {
            throw Error(err);
          });

        return ApiResult;
      },

      /**
       * Returns percentage of all users who checked this activity today
       * this.$store.getters['activityentry/api'].Custom.ActivityPercentageDayFriends(ActivityId)
       */
      ActivityPercentageDayFriends: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/activities/" +
            Id +
            "/percentage-day-friends",
          {}
        );

        let data = ApiResult.data.data;

        return data;
      },

      /**
       * Returns percentage of all users who checked this activity today
       * this.$store.getters['activityentry/api'].Custom.ActivityPercentageDayAll(ActivityId)
       */
      ActivityPercentageDayAll: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/activities/" +
            Id +
            "/percentage-day-all",
          {}
        );

        let data = ApiResult.data.data;

        return data;
      },

      /**
       * Returns percentage of all users who checked this activity this week
       * this.$store.getters['activityentry/api'].Custom.ActivityPercentageWeekFriends(ActivityId)
       */
      ActivityPercentageWeekFriends: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/activities/" +
            Id +
            "/percentage-week-friends",
          {}
        );

        let data = ApiResult.data.data;

        return data;
      },

      /**
       * Returns percentage of all users who checked this activity this week
       * this.$store.getters['activityentry/api'].Custom.ActivityPercentageWeekAll(ActivityId)
       */
      ActivityPercentageWeekAll: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.get(
          process.env.VUE_APP_BASE_URL +
            "/api/activities/" +
            Id +
            "/percentage-week-all",
          {}
        );

        let data = ApiResult.data.data;

        return data;
      },

      /**
       * Creates an ActivityEntry
       * this.$store.getters['activityentry/api'].Custom.Check(ActivityId)
       */
      Check: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/activities/" + Id + "/check",
          {}
        );

        let data = new ActivityEntry(ApiResult.data.data);
        state.activityEntries.push(data);
        return data;
      },

      /**
       * Deletes an ActivityEntry
       * this.$store.getters['activityentry/api'].Custom.Uncheck(ActivityId)
       */
      Uncheck: async (Id) => {
        const api = new ApiAsyncHelper();
        const ApiResult = await api.$http.post(
          process.env.VUE_APP_BASE_URL + "/api/activities/" + Id + "/uncheck",
          {}
        );

        let data = ApiResult.data.data.message;

        let el = state.activityEntries.findIndex((e) => e.id === data);
        state.activityEntries.splice(el, 1);

        return data;
      },
    }
  )
);

// mutations
export const mutations = {};

export const actions = new BaseApiRoutes(
  process.env.VUE_APP_BASE_URL + "/api/activity-entries",
  [],
  {}
);
